export namespace TrackingStorage {
  export function getLocalStorageCount(name: string, storageKey: string): number {
    try {
      const storage = window.localStorage;
      const localStorageValue = JSON.parse(storage.getItem(storageKey) || "{}");

      return localStorageValue[name] || 0;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);

      return 0;
    }
  }

  export function setLocalStorageCount(name: string, storageKey: string, count: number): void {
    try {
      const storage = window.localStorage;
      const localStorageValue = JSON.parse(storage.getItem(storageKey) || "{}");
      localStorageValue[name] = count;

      storage.setItem(storageKey, JSON.stringify(localStorageValue));
    } catch (error) {
      // eslint-disable-next-line no-console
      console.log(error);
    }
  }
}
